import { Box } from '@mui/material';
import DocumentPreviewRenderer from './DocumentTemplatePreviewSection/DocumentPreviewRenderer';

type CollapsibleDocumentPreviewProps = {
  documentPath: string;
  blobUrl: string;
  loading: boolean;
  hasError: Nullable<boolean>;
  isExpanded: boolean;
};

const CollapsibleDocumentPreview = ({
  documentPath,
  blobUrl,
  loading,
  hasError,
  isExpanded,
}: CollapsibleDocumentPreviewProps) => (
  <Box
    height="580px"
    width="100%"
    sx={{
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      ...(isExpanded
        ? {}
        : {
            height: 60,
            overflow: 'hidden',
            WebkitMaskImage:
              'linear-gradient(to top, var(--mui-palette-common-transparentWhite) 15%, var(--mui-palette-common-loadingOverlay) 55%)',
            maskImage:
              'linear-gradient(to top, var(--mui-palette-common-transparentWhite) 15%, var(--mui-palette-common-loadingOverlay) 55%)',
            WebkitMaskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
          }),
    }}
  >
    <DocumentPreviewRenderer
      documentPath={documentPath}
      blobUrl={blobUrl}
      loading={loading}
      hasError={Boolean(hasError)}
    />
  </Box>
);

export default CollapsibleDocumentPreview;
